(() => {
  const colorOrder = Object.freeze(['White', 'Black', 'Pink']);
  const colorRank = new Map(colorOrder.map((color, index) => [color, index]));
  const expectedGroups = Object.freeze({
    '1|0': Object.freeze({ price: 2299, compare: 2599 }),
    '1|1': Object.freeze({ price: 2599, compare: 2899 }),
    '2|0': Object.freeze({ price: 3899, compare: 6499 }),
    '2|2': Object.freeze({ price: 4399, compare: 7299 })
  });
  const mappingRows = Object.freeze([
    { quantity: 1, colors: ['White'], cables: 0, sku: 'CM-F151EE5425AC', colorOption: 'White · No Cable', piecesOption: '1 Charger' },
    { quantity: 1, colors: ['Black'], cables: 0, sku: 'CM-022F512ADD3E', colorOption: 'Black · No Cable', piecesOption: '1 Charger' },
    { quantity: 1, colors: ['Pink'], cables: 0, sku: 'CM-0A4ADD833F6A', colorOption: 'Pink · No Cable', piecesOption: '1 Charger' },
    { quantity: 1, colors: ['White'], cables: 1, sku: 'CM-72B458D589D4', colorOption: 'White · 1 Cable', piecesOption: '1 Charger' },
    { quantity: 1, colors: ['Black'], cables: 1, sku: 'CM-1C12A979FE96', colorOption: 'Black · 1 Cable', piecesOption: '1 Charger' },
    { quantity: 1, colors: ['Pink'], cables: 1, sku: 'CM-466D1F55E4D0', colorOption: 'Pink · 1 Cable', piecesOption: '1 Charger' },
    { quantity: 2, colors: ['White', 'White'], cables: 0, sku: 'CM-AA2BE7CE0DAD', colorOption: 'White + White · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['White', 'Black'], cables: 0, sku: '3732-2CH-WHITE-BLACK-NO-CABLE', colorOption: 'White + Black · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['White', 'Pink'], cables: 0, sku: '3732-2CH-WHITE-PINK-NO-CABLE', colorOption: 'White + Pink · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Black', 'Black'], cables: 0, sku: 'CM-C2F1C3AC9D22', colorOption: 'Black + Black · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Black', 'Pink'], cables: 0, sku: '3732-2CH-BLACK-PINK-NO-CABLE', colorOption: 'Black + Pink · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Pink', 'Pink'], cables: 0, sku: 'CM-35AF42F795D6', colorOption: 'Pink + Pink · No Cable', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['White', 'White'], cables: 2, sku: 'CM-3CB601E0E6CF', colorOption: 'White + White · 2 Cables', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['White', 'Black'], cables: 2, sku: '3732-2CH-WHITE-BLACK-2-CABLES', colorOption: 'White + Black · 2 Cables', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['White', 'Pink'], cables: 2, sku: '3732-2CH-WHITE-PINK-2-CABLES', colorOption: 'White + Pink · 2 Cables', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Black', 'Black'], cables: 2, sku: 'CM-0275C630256A', colorOption: 'Black + Black · 2 Cables', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Black', 'Pink'], cables: 2, sku: '3732-2CH-BLACK-PINK-2-CABLES', colorOption: 'Black + Pink · 2 Cables', piecesOption: '2 Chargers' },
    { quantity: 2, colors: ['Pink', 'Pink'], cables: 2, sku: 'CM-8017948929D7', colorOption: 'Pink + Pink · 2 Cables', piecesOption: '2 Chargers' }
  ]);

  function canonicalColors(colors) {
    return colors
      .slice()
      .sort((left, right) => (colorRank.get(left) ?? 99) - (colorRank.get(right) ?? 99));
  }

  function selectionKey(quantity, colors, cables) {
    return JSON.stringify([quantity, canonicalColors(colors), cables]);
  }

  function groupKey(quantity, cables) {
    return `${quantity}|${cables}`;
  }

  document.querySelectorAll('[data-wc3-root]').forEach((root) => {
    if (root.dataset.wc3Initialized === 'true') return;
    root.dataset.wc3Initialized = 'true';

    const currency = root.dataset.currency || 'USD';
    const quantityCards = Array.from(root.querySelectorAll('[data-wc3-quantity]'));
    const colorSelectors = Array.from(root.querySelectorAll('[data-wc3-color-selector]'));
    const colorButtons = Array.from(root.querySelectorAll('[data-wc3-color]'));
    const cableButtons = Array.from(root.querySelectorAll('[data-wc3-cable]'));
    const galleryMedia = Array.from(root.querySelectorAll('[data-wc3-media]'));
    const galleryThumbs = Array.from(root.querySelectorAll('[data-wc3-thumb]'));
    const variantsNode = root.querySelector('[data-wc3-native-variants]');
    const selectionLabel = root.querySelector('[data-wc3-selection]');
    const totalLabel = root.querySelector('[data-wc3-total]');
    const stickyLabel = root.querySelector('[data-wc3-sticky-label]');
    const stickyPrice = root.querySelector('[data-wc3-sticky-price]');
    const addButton = root.querySelector('[data-wc3-add]');
    const addLabel = root.querySelector('[data-wc3-add-label]');
    const stickyButton = root.querySelector('[data-wc3-sticky-button]');
    const stickyButtonLabel = root.querySelector('[data-wc3-sticky-button-label]');
    const form = root.querySelector('[data-wc3-form]');
    const variantIdInput = root.querySelector('[data-wc3-variant-id]');
    const lineQuantityInput = root.querySelector('[data-wc3-line-quantity]');
    const quantityProperty = root.querySelector('[data-wc3-property-quantity]');
    const colorOneProperty = root.querySelector('[data-wc3-property-color-one]');
    const colorTwoProperty = root.querySelector('[data-wc3-property-color-two]');
    const cableOptionProperty = root.querySelector('[data-wc3-property-cable-option]');
    const cableQuantityProperty = root.querySelector('[data-wc3-property-cable-quantity]');
    const compositionProperty = root.querySelector('[data-wc3-property-composition]');
    const sticky = root.querySelector('[data-wc3-sticky]');
    const buy = root.querySelector('#wc3-buy');

    const initialQuantityCard = quantityCards.find((card) => card.classList.contains('is-selected')) || quantityCards[0];
    const initialCableButton = cableButtons.find((button) => button.classList.contains('is-selected')) || cableButtons[0];
    let selectedQuantity = Number(initialQuantityCard?.dataset.wc3Quantity || 1);
    let includesCable = initialCableButton?.dataset.cable === 'true';
    let activeColorSelectorIndex = 0;

    function money(cents) {
      const numeric = Number(cents);
      const amount = Number.isFinite(numeric) ? numeric / 100 : 0;

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (_error) {
        return `$${amount.toFixed(2)}`;
      }
    }

    let nativeVariants = [];
    try {
      const parsed = JSON.parse(variantsNode?.textContent || '[]');
      nativeVariants = Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      nativeVariants = [];
    }

    const variantsBySku = new Map();
    const nativeIds = new Set();
    let matrixHealthy = nativeVariants.length === mappingRows.length;

    nativeVariants.forEach((rawVariant) => {
      const variant = {
        id: String(rawVariant?.id || ''),
        title: String(rawVariant?.title || ''),
        sku: String(rawVariant?.sku || '').trim(),
        options: Array.isArray(rawVariant?.options) ? rawVariant.options.map(String) : [],
        price: Number(rawVariant?.price),
        compareAtPrice: Number(rawVariant?.compareAtPrice),
        available: rawVariant?.available === true
      };
      if (!variant.id || !variant.sku || variant.options.length !== 2 || !Number.isInteger(variant.price) || variant.price <= 0) {
        matrixHealthy = false;
      }
      if (nativeIds.has(variant.id)) matrixHealthy = false;
      nativeIds.add(variant.id);
      const bucket = variantsBySku.get(variant.sku) || [];
      bucket.push(variant);
      variantsBySku.set(variant.sku, bucket);
    });

    const resolvedBySelection = new Map();
    const expectedSkus = new Set();
    mappingRows.forEach((row) => {
      const key = selectionKey(row.quantity, row.colors, row.cables);
      const candidates = variantsBySku.get(row.sku) || [];
      const expectedPrice = expectedGroups[groupKey(row.quantity, row.cables)];
      expectedSkus.add(row.sku);
      if (resolvedBySelection.has(key) || candidates.length !== 1 || !expectedPrice) {
        matrixHealthy = false;
        return;
      }
      const variant = candidates[0];
      if (
        variant.options[0] !== row.colorOption ||
        variant.options[1] !== row.piecesOption ||
        variant.price !== expectedPrice.price ||
        variant.compareAtPrice !== expectedPrice.compare
      ) {
        matrixHealthy = false;
        return;
      }
      resolvedBySelection.set(key, { row, variant });
    });

    if (
      resolvedBySelection.size !== mappingRows.length ||
      expectedSkus.size !== mappingRows.length ||
      variantsBySku.size !== mappingRows.length ||
      Array.from(variantsBySku).some(([sku, variants]) => !expectedSkus.has(sku) || variants.length !== 1)
    ) {
      matrixHealthy = false;
    }

    root.dataset.wc3MappingStatus = matrixHealthy ? 'ready' : 'blocked';

    function buttonsForColorSelector(selector) {
      return Array.from(selector?.querySelectorAll('[data-wc3-color]') || []);
    }

    function selectedColorButton(index) {
      const selector = colorSelectors[index];
      const buttons = buttonsForColorSelector(selector);
      return buttons.find((button) => button.classList.contains('is-selected')) || buttons[0];
    }

    function selectedColors(quantity = selectedQuantity) {
      return colorSelectors
        .slice(0, quantity)
        .map((_selector, index) => selectedColorButton(index)?.dataset.color || 'White');
    }

    function cableCount(quantity = selectedQuantity, cableIncluded = includesCable) {
      return cableIncluded ? quantity : 0;
    }

    function mappingFor(quantity, colors, cables) {
      return resolvedBySelection.get(selectionKey(quantity, colors, cables)) || null;
    }

    function currentMapping() {
      return mappingFor(selectedQuantity, selectedColors(), cableCount());
    }

    function configurationLabel() {
      const colors = selectedColors();
      const cables = cableCount();
      const cableLabel = cables === 0
        ? 'No Cable'
        : cables === 1
          ? '1 Cable Included'
          : `${cables} Cables Included (1 per charger)`;

      if (selectedQuantity === 1) {
        return `1 ${colors[0]} Charger · ${cableLabel}`;
      }
      return `${selectedQuantity} Chargers: ${colors.join(' + ')} · ${cableLabel}`;
    }

    function groupPricing(quantity, cables) {
      const rows = mappingRows.filter((row) => row.quantity === quantity && row.cables === cables);
      const mappings = rows.map((row) => mappingFor(row.quantity, row.colors, row.cables));
      if (!matrixHealthy || mappings.some((mapping) => !mapping)) return null;
      const prices = new Set(mappings.map((mapping) => mapping.variant.price));
      const compares = new Set(mappings.map((mapping) => mapping.variant.compareAtPrice));
      if (prices.size !== 1 || compares.size !== 1) return null;
      return {
        price: mappings[0].variant.price,
        compare: mappings[0].variant.compareAtPrice,
        available: mappings.some((mapping) => mapping.variant.available)
      };
    }

    function refreshQuantityCards() {
      quantityCards.forEach((card) => {
        const quantity = Number(card.dataset.wc3Quantity || 1);
        const cables = cableCount(quantity, includesCable);
        const pricing = groupPricing(quantity, cables);
        const priceNode = card.querySelector('[data-wc3-card-price]');
        const compareNode = card.querySelector('[data-wc3-card-compare]');
        const savingNode = card.querySelector('[data-wc3-card-saving]');
        const unitNode = card.querySelector('[data-wc3-unit-price]');
        const isSelected = quantity === selectedQuantity;

        if (pricing) {
          const saving = Math.max(0, pricing.compare - pricing.price);
          if (priceNode) priceNode.textContent = money(pricing.price);
          if (compareNode) compareNode.textContent = money(pricing.compare);
          if (savingNode) savingNode.textContent = `Save ${money(saving)}`;
          if (unitNode) unitNode.textContent = `${money(Math.round(pricing.price / quantity))} each`;
        }
        card.disabled = !pricing || !pricing.available;
        card.setAttribute('aria-disabled', card.disabled ? 'true' : 'false');
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function refreshColorSelectors() {
      colorSelectors.forEach((selector, index) => {
        selector.hidden = index >= selectedQuantity;
        const buttons = buttonsForColorSelector(selector);
        const selectedButton = selectedColorButton(index);
        buttons.forEach((button) => {
          const isSelected = button === selectedButton;
          const candidateColors = selectedColors();
          candidateColors[index] = button.dataset.color || 'White';
          const mapping = mappingFor(selectedQuantity, candidateColors, cableCount());
          button.disabled = !matrixHealthy || !mapping || !mapping.variant.available;
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      });
    }

    function refreshCableButtons() {
      cableButtons.forEach((button) => {
        const cableIncluded = button.dataset.cable === 'true';
        const cables = cableCount(selectedQuantity, cableIncluded);
        const mapping = mappingFor(selectedQuantity, selectedColors(), cables);
        const isSelected = cableIncluded === includesCable;
        button.disabled = !matrixHealthy || !mapping || !mapping.variant.available;
        button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        const detail = button.querySelector('[data-wc3-cable-count]');
        if (detail) {
          detail.textContent = selectedQuantity === 1
            ? '1 cable included'
            : `${selectedQuantity} cables included · 1 per charger`;
        }
      });
    }

    function refreshOrderProperties() {
      const colors = selectedColors();
      const cables = cableCount();
      const composition = configurationLabel();

      if (quantityProperty) quantityProperty.value = `${selectedQuantity} ${selectedQuantity === 1 ? 'Charger' : 'Chargers'}`;
      if (colorOneProperty) colorOneProperty.value = colors[0] || '';
      if (colorTwoProperty) {
        colorTwoProperty.value = selectedQuantity === 2 ? colors[1] || '' : '';
        colorTwoProperty.disabled = selectedQuantity !== 2;
      }
      if (cableOptionProperty) cableOptionProperty.value = includesCable ? 'Included' : 'Not Included';
      if (cableQuantityProperty) cableQuantityProperty.value = String(cables);
      if (compositionProperty) compositionProperty.value = composition;
      if (lineQuantityInput) lineQuantityInput.value = '1';
    }

    function refreshPurchaseDisplay() {
      const mapping = currentMapping();
      const variant = mapping?.variant || null;
      const label = configurationLabel();
      const canPurchase = Boolean(
        root.dataset.checkoutEnabled === 'true' &&
        form?.dataset.wc3SubmitEnabled === 'true' &&
        matrixHealthy &&
        variant?.id &&
        variant?.sku &&
        variant.available &&
        Number.isInteger(variant.price) &&
        variant.price > 0
      );

      refreshQuantityCards();
      refreshColorSelectors();
      refreshCableButtons();
      refreshOrderProperties();

      if (selectionLabel) selectionLabel.textContent = label;
      if (totalLabel && variant) totalLabel.textContent = money(variant.price);
      if (stickyLabel) stickyLabel.textContent = label;
      if (stickyPrice && variant) stickyPrice.textContent = money(variant.price);
      if (variantIdInput) {
        variantIdInput.value = canPurchase ? variant.id : '';
        variantIdInput.disabled = !canPurchase;
      }

      const buttonText = canPurchase ? 'Add to Cart' : variant && !variant.available ? 'Sold Out' : 'Unavailable';
      if (addLabel) addLabel.textContent = buttonText;
      if (stickyButtonLabel) stickyButtonLabel.textContent = buttonText;
      if (addButton) {
        addButton.disabled = !canPurchase;
        addButton.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
      }
      if (stickyButton) {
        stickyButton.disabled = !canPurchase;
        stickyButton.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
      }

      root.dataset.wc3MappedVariantId = canPurchase ? variant.id : '';
      root.dataset.wc3MappedSku = canPurchase ? variant.sku : '';
      root.dataset.wc3SelectionAvailable = canPurchase ? 'true' : 'false';
      return { canPurchase, variant };
    }

    function showGalleryMedia(mediaIndex) {
      const key = String(mediaIndex);
      galleryMedia.forEach((media) => {
        media.classList.toggle('is-hidden', media.dataset.wc3Media !== key);
      });
      galleryThumbs.forEach((thumb) => {
        const isActive = thumb.dataset.wc3Thumb === key;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function showSelectedColorMedia(index) {
      const button = selectedColorButton(index);
      const mediaIndex = includesCable ? button?.dataset.mediaCable : button?.dataset.mediaNoCable;
      if (mediaIndex) showGalleryMedia(mediaIndex);
    }

    quantityCards.forEach((card) => {
      card.addEventListener('click', () => {
        if (card.disabled) return;
        selectedQuantity = Number(card.dataset.wc3Quantity || 1);
        activeColorSelectorIndex = Math.min(activeColorSelectorIndex, selectedQuantity - 1);
        refreshPurchaseDisplay();
        showSelectedColorMedia(activeColorSelectorIndex);
      });
    });

    colorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const selector = button.closest('[data-wc3-color-selector]');
        const selectorIndex = Number(selector?.dataset.selectorIndex || 0);
        buttonsForColorSelector(selector).forEach((candidate) => candidate.classList.remove('is-selected'));
        button.classList.add('is-selected');
        activeColorSelectorIndex = selectorIndex;
        refreshPurchaseDisplay();
        showSelectedColorMedia(selectorIndex);
      });
    });

    cableButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        includesCable = button.dataset.cable === 'true';
        refreshPurchaseDisplay();
        showSelectedColorMedia(activeColorSelectorIndex);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showGalleryMedia(thumb.dataset.wc3Thumb));
    });

    if (form) {
      form.addEventListener('submit', (event) => {
        const state = refreshPurchaseDisplay();
        if (!state.canPurchase || !variantIdInput?.value || lineQuantityInput?.value !== '1') {
          event.preventDefault();
        }
      });
    }

    if (stickyButton && form && addButton) {
      stickyButton.addEventListener('click', () => {
        const state = refreshPurchaseDisplay();
        if (state.canPurchase) form.requestSubmit(addButton);
      });
    }

    if (sticky && buy && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.08 }
      );
      observer.observe(buy);
    }

    refreshPurchaseDisplay();
  });
})();
